import { render } from "./base-spinner.vue?vue&type=template&id=cfb03f34&ts=true"
import script from "./base-spinner.vue?vue&type=script&lang=ts"
export * from "./base-spinner.vue?vue&type=script&lang=ts"

import "./base-spinner.vue?vue&type=style&index=0&id=cfb03f34&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__